// Traduções do Painel de Diárias — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'diarias.title': 'Painel de Diárias',
    'diarias.eyebrow': 'Operação',
    'diarias.loadError': 'Não foi possível carregar as diárias.',
    'diarias.retry': 'Tentar de novo',
    'diarias.grade': 'Diárias por colaborador',
    'diarias.empty': 'Nenhuma linha no período filtrado.',
    'diarias.count_one': '{{count}} linha',
    'diarias.count_other': '{{count}} linhas',
    'diarias.hint': 'Clique na coluna do HUB para lançar',
    'diarias.sincronizadoEm': 'ERP lido às {{hora}}',
    'diarias.semSincronia': 'O ERP ainda não foi lido',

    'diarias.de': 'De',
    'diarias.ate': 'Até',
    'diarias.filtro.colaborador': 'Colaborador',
    'diarias.filtro.todos': 'Todos',
    'diarias.filtro.origem': 'Origem',

    'diarias.grupo.identificacao': 'Colaborador',
    'diarias.grupo.erp': 'Lançado no ERP',
    'diarias.grupo.hub': 'Decidido no HUB',
    'diarias.grupo.jornada': 'Jornada apurada',

    'diarias.col.data': 'Data',
    'diarias.col.diaSemana': 'Dia',
    'diarias.col.nome': 'Nome',
    'diarias.col.matricula': 'Matrícula',
    'diarias.col.funcao': 'Função',
    'diarias.col.status': 'Diária',
    'diarias.col.tipo': 'Tipo',
    'diarias.col.valor': 'Valor',
    'diarias.col.observacao': 'Observação',
    'diarias.col.usuario': 'Por',
    'diarias.col.lancadoEm': 'Em',
    'diarias.col.grupo': 'Dupla no dia',
    'diarias.col.estado': 'Situação',
    'diarias.col.statusDia': 'Apurado',
    'diarias.col.direcao': 'Direção',
    'diarias.col.jornada': 'Jornada',
    'diarias.col.base': 'Base',
    'diarias.col.municipio': 'Município origem',

    'diarias.origem.hub': 'HUB',
    'diarias.origem.erp': 'ERP',
    'diarias.origem.vazio': 'Sem lançamento',
    'diarias.estado.rascunho': 'Só no HUB',
    'diarias.estado.enviado': 'No ERP',
    'diarias.automatico': 'Automático',
    'diarias.subidoPor': 'Subido por {{nome}}',


    'diarias.kpi.linhas': 'Linhas',
    'diarias.kpi.linhasHint': 'colaboradores por dias do período',
    'diarias.kpi.trabalho': 'Trabalho',
    'diarias.kpi.folga': 'Folga',
    'diarias.kpi.disposicao': 'Disposição',
    'diarias.kpi.diasHint': 'dias no período',
    'diarias.kpi.disponivel': 'Disponível',
    'diarias.kpi.disponivelHint': 'em branco ou disponível no ERP',
    'diarias.kpi.inconsistencias': 'Inconsistências',
    'diarias.kpi.inconsistenciasHint': 'marcadas pelo próprio ERP',
    'diarias.kpi.doHub': 'Decididos no HUB',
    'diarias.kpi.doHubHint': 'de {{rascunhos}} ainda fora do ERP',
    'diarias.kpi.valor': 'Valor total',
    'diarias.kpi.valorHint': 'somado no período filtrado',

    'diarias.lancar.titulo': 'Lançar diária',
    'diarias.lancar.limpar': 'Usar o que o ERP tem',
    'diarias.lancar.semPermissao': 'Você não tem permissão para lançar diária.',
    'diarias.lancar.erro': 'Não foi possível gravar a diária.',
    'diarias.vocabNovo_one': 'O ERP passou a usar um valor que esta tela ainda não conhece: {{lista}}',
    'diarias.vocabNovo_other': 'O ERP passou a usar {{count}} valores que esta tela ainda não conhece: {{lista}}',
    'diarias.vocabNovoDica': 'A grade mostra o valor como ele veio, e a conferência não sabe classificá-lo. Vale avisar a equipe do Protheus e acrescentá-lo à lista.',

    'diarias.export.grade': 'Baixar Excel',
    'diarias.export.gradeDica': 'A grade como está filtrada, para conferência.',
    'diarias.export.lancamentos': 'Exportar lançamentos',
    'diarias.export.csv': 'Gerar CSV',
    'diarias.export.csvDica': 'O arquivo de importação do ERP: filial, matrícula, lançamento e tipo como código, e observação. Leva o que o HUB decidiu no período e o Protheus ainda não tem. O lançamento sem Motivo ou sem código do ERP fica de fora.',
    'diarias.codigos.abrir': 'Códigos do ERP',
    'diarias.codigos.titulo': 'Códigos do ERP no CSV',
    'diarias.codigos.intro': 'O código que o Protheus espera para cada diária e cada tipo. O campo vazio vale o código já conhecido, mostrado em cinza. Valor sem código trava o CSV: o arquivo não sai, e a mensagem diz quais valores faltam cadastrar aqui.',
    'diarias.codigos.status': 'Código da diária',
    'diarias.codigos.tipos': 'Tipos',
    'diarias.codigos.semCodigo': 'Sem código',
    'diarias.codigos.travaCsv': 'Trava o CSV',
    'diarias.codigos.salvo': 'Códigos gravados. O próximo CSV já sai com eles.',
    'diarias.codigos.erro': 'Não foi possível gravar os códigos.',
    'diarias.export.lancamentosDica': 'Só o que o HUB decidiu e o ERP ainda não tem, no formato do lançamento.',
    'diarias.export.vazio': 'Não há linha para exportar.',

    'diarias.tela.diarias': 'Painel de Diárias',
    'diarias.tela.lancamento': 'Painel de Lançamento',
    'diarias.tela.conferencia': 'Painel de Conferência',

    'diarias.filtro.funcao': 'Função',
    'diarias.filtro.tipo': 'Tipo',
    'diarias.filtro.usuario': 'Responsável pelo lançamento',
    'diarias.filtro.automatico': 'Automático',
    'diarias.col.dupla': 'Dupla',
    'diarias.col.duplaDoDiaErp': 'No ERP, a dupla neste dia era {{dupla}}',
    'diarias.origem.chipHub': 'HUB',

    'diarias.status.TRABALHO': 'Trabalho',
    'diarias.status.DISPOSICAO': 'Disposição',
    'diarias.status.FOLGA': 'Folga',
    'diarias.status.DISPONIVEL': 'Disponível',
    'diarias.status.INCONSISTENTE': 'Inconsistente',
    'diarias.status.AFASTAMENTO': 'Afastamento',
    'diarias.status.FERIAS': 'Férias',
    'diarias.status.FALTA': 'Falta',
    'diarias.status.SUSPENSAO': 'Suspensão',
    'diarias.status.OUTROS': 'Outros',

    'diarias.pizza.titulo': 'Diárias por status',
    'diarias.pizza.centro': 'linhas',
    'diarias.pizza.vazio': 'Nenhuma diária no período filtrado.',
    'diarias.pizza.outrosDica': 'Valores que esta tela ainda não conhece.',

    'diarias.duplasHoje.titulo': 'Colaboradores por dupla',
    'diarias.duplasHoje.hoje': 'situação de hoje, {{dia}}',
    'diarias.duplasHoje.semDupla': 'Sem dupla',
    'diarias.duplasHoje.vazio': 'Ninguém no quadro hoje.',
    'diarias.duplasHoje.trabalho': 'Trabalho',
    'diarias.duplasHoje.folga': 'Folga',
    'diarias.duplasHoje.disponivel': 'Disponível',
    'diarias.duplasHoje.outros': 'Outros',
    'diarias.duplasHoje.total_one': '{{count}} colaborador',
    'diarias.duplasHoje.total_other': '{{count}} colaboradores',

    'diarias.seq.domingos': 'Domingos trabalhados seguidos',
    'diarias.seq.dias': 'Dias trabalhados seguidos',
    'diarias.seq.folgas': 'Folgas seguidas',
    'diarias.seq.desde': 'desde {{dia}}',
    'diarias.seq.ancora': 'medido até {{dia}}',
    'diarias.seq.vazio': 'Ninguém em sequência.',
    'diarias.seq.regra': 'Disponível e inconsistente não contam nem interrompem. Afastamento, férias, falta e suspensão zeram. Disposição conta como trabalho.',

    'diarias.lanc.grade': 'Disponíveis para lançar',
    'diarias.lanc.resumo.alcance': 'Dados de {{de}} a {{ate}}',
    'diarias.lanc.resumo.periodos': 'Disponíveis por período',
    'diarias.lanc.resumo.periodo': 'Período',
    'diarias.lanc.resumo.duplas': 'Disponíveis por dupla',
    'diarias.lanc.resumo.dias': 'Disponíveis por dia',
    'diarias.lanc.resumo.quantidade': 'Quantidade',
    'diarias.lanc.resumo.intervalo': '{{de}} a {{ate}}',
    'diarias.lanc.resumo.semDupla': 'Sem dupla',
    'diarias.lanc.empty': 'Nenhuma linha disponível até hoje no período filtrado.',
    'diarias.lanc.kpi.disponiveis': 'Disponíveis',
    'diarias.lanc.kpi.disponiveisHint': 'até hoje, sem decisão',
    'diarias.lanc.kpi.alerta1': 'Disponível há 1 dia',
    'diarias.lanc.kpi.alerta2': 'Disponível há 2 dias',
    'diarias.lanc.kpi.alerta3': 'Disponível há 3 dias ou mais',
    'diarias.lanc.kpi.alertaHint': 'clique para filtrar',
    'diarias.lanc.filtro.alerta': 'Alerta',
    'diarias.lanc.filtro.jornada': 'Jornada',
    'diarias.lanc.filtro.semLancamento': 'Sem lançamento',
    'diarias.lanc.alerta.1': '1 dia',
    'diarias.lanc.alerta.2': '2 dias',
    'diarias.lanc.alerta.3': '3 dias ou mais',
    'diarias.lanc.jornada.sim': 'Com jornada',
    'diarias.lanc.jornada.nao': 'Sem jornada',
    'diarias.lanc.grupo.colaborador': 'Colaborador',
    'diarias.lanc.grupo.jornada': 'Jornada',
    'diarias.lanc.grupo.lancamento': 'Lançamento',
    'diarias.lanc.col.cliente': 'Cliente',
    'diarias.lanc.col.veiculo': 'Veículo',
    'diarias.lanc.col.inicio': 'Início',
    'diarias.lanc.col.refeicao': 'Refeição',
    'diarias.lanc.col.fim': 'Fim',
    'diarias.lanc.col.total': 'Total',
    'diarias.lanc.col.direcao': 'Direção',
    'diarias.lanc.col.parado': 'Parado',
    'diarias.lanc.col.distancia': 'Distância',
    'diarias.lanc.col.responsavel': 'Responsável',
    'diarias.lanc.col.alerta': 'Alerta',
    'diarias.lanc.jornadas': '{{count}} jornadas no dia. Os marcos são da primeira.',
    'diarias.lanc.previsao': 'Previsão',
    'diarias.lanc.previsaoDica': 'O que o HUB preveria para este dia pela jornada. A rotina da manhã grava a previsão sozinha.',
    'diarias.lanc.salvo': 'Rascunho salvo. A diária será confirmada após o registro no Protheus.',
    'diarias.lanc.semGaragem_one': 'A base {{lista}} não tem garagem cadastrada em Locais. A previsão automática fica em branco para ela.',
    'diarias.lanc.semGaragem_other': 'As bases {{lista}} não têm garagem cadastrada em Locais. A previsão automática fica em branco para elas.',
    'diarias.lanc.semGaragemDica': 'Cadastre o local com a categoria Garagem, a cidade no nome e a coordenada. O raio de 30 km é medido dela.',
    'diarias.previsao.TRABALHO': 'Trabalho',
    'diarias.previsao.DISPOSICAO_FORA': 'Disposição fora da base',
    'diarias.previsao.DISPOSICAO_DENTRO': 'Disposição na base',
    'diarias.previsao.DISPOSICAO_GARAGEM': 'Disposição garagem',
    'diarias.previsao.FOLGA': 'Folga',
    'diarias.origem.chipPrevisto': 'HUB',
    'diarias.origem.previstoDica': 'Previsto automaticamente pela jornada. Para mudar, escolha a diária que valeu.',

    'diarias.conf.grade': 'Alertas da conferência',
    'diarias.conf.empty': 'Nenhum alerta no período filtrado.',
    'diarias.conf.count_one': '{{count}} alerta',
    'diarias.conf.count_other': '{{count}} alertas',
    'diarias.conf.inicio': 'conferências desde {{dia}}',
    'diarias.conf.kpi.total': 'Alertas',
    'diarias.conf.kpi.totalHint': 'no período filtrado',
    'diarias.conf.kpi.pendente': 'Pendentes',
    'diarias.conf.kpi.corrigido': 'Corrigidos',
    'diarias.conf.kpi.justificado': 'Justificados',
    'diarias.conf.kpi.advertencia': 'Gestões',
    'diarias.conf.kpi.statusHint': 'clique para filtrar',
    'diarias.conf.filtro.tipo': 'Alerta',
    'diarias.conf.filtro.status': 'Status da conferência',
    'diarias.conf.col.responsavel': 'Responsável pelo lançamento',
    'diarias.conf.col.alerta': 'Alerta',
    'diarias.conf.col.status': 'Status',
    'diarias.conf.col.justificativa': 'Justificativa',
    'diarias.conf.col.jornada': 'Jornada',
    'diarias.conf.col.distancia': 'Distância',
    'diarias.conf.tipo.folga_com_jornada': 'Folga com jornada',
    'diarias.conf.tipo.falta_com_jornada': 'Falta com jornada',
    'diarias.conf.tipo.suspensao_com_jornada': 'Suspensão com jornada',
    'diarias.conf.tipo.ferias_com_jornada': 'Férias com jornada',
    'diarias.conf.tipo.afastamento_com_jornada': 'Afastamento com jornada',
    'diarias.conf.tipo.ociosos_com_jornada': 'Ocioso com jornada',
    'diarias.conf.tipo.trabalho_incorreto': 'Trabalho incorreto',
    'diarias.conf.tipo.disposicao_incorreta': 'Disposição incorreta',
    'diarias.conf.tipo.lancamento_inconsistente': 'Lançamento inconsistente',
    'diarias.conf.tipo.diaria_duplicada': 'Diária duplicada',
    'diarias.conf.tipo.disposicao_com_hora_extra': 'Disposição com hora extra',
    'diarias.conf.tipo.folga_com_jornadaDica': 'A diária diz folga e há jornada aberta no dia.',
    'diarias.conf.tipo.falta_com_jornadaDica': 'A diária diz falta e há jornada aberta no dia.',
    'diarias.conf.tipo.suspensao_com_jornadaDica': 'A diária diz suspensão e há jornada aberta no dia.',
    'diarias.conf.tipo.ferias_com_jornadaDica': 'A diária diz férias e há jornada aberta no dia.',
    'diarias.conf.tipo.afastamento_com_jornadaDica': 'A diária diz afastamento e há jornada aberta no dia.',
    'diarias.conf.tipo.ociosos_com_jornadaDica': 'Há jornada no dia e o Protheus programou a pessoa na dupla dos funcionários ociosos. Vale qualquer que seja a diária, e vira Corrigido quando o Protheus tira a pessoa da dupla de ociosos no dia ou no cadastro.',
    'diarias.conf.tipo.trabalho_incorretoDica': 'O lançado é Trabalho e está errado. Motorista e prancheiro: a jornada indica Disposição. Operador e manobra: Trabalho lançado sem jornada no dia.',
    'diarias.conf.tipo.disposicao_incorretaDica': 'O lançado é Disposição e está errado: a jornada indica Trabalho, ou é Disposição do outro lado da base.',
    'diarias.conf.tipo.lancamento_inconsistenteDica': 'O próprio Protheus classificou o dia como inconsistente. Ele faz isso quando a programação do dia tem mais de um tipo marcado, como trabalho e folga.',
    'diarias.conf.tipo.diaria_duplicadaDica': 'O Protheus devolveu dois ou mais lançamentos para o mesmo colaborador no mesmo dia. O HUB confere o primeiro e guarda todos aqui.',
    'diarias.conf.origem.titulo': 'Lançamentos no ERP',
    'diarias.conf.origem.lancamento': 'Lançamento {{n}}',
    'diarias.conf.origem.marcado': 'Marcado',
    'diarias.conf.origem.observacao': 'Observação',
    'diarias.conf.origem.usuario': 'Lançado por',
    'diarias.conf.origem.data': 'Lançado em',
    'diarias.conf.origem.semMarca': 'Nenhum tipo marcado',
    'diarias.conf.origem.semMarcasDoErp': 'Retrato de antes de 23/09/2026, quando o ERP ainda não enviava Falta, Férias e Folga. Enquanto o alerta estiver pendente, ele se atualiza na próxima leitura do ERP.',
    'diarias.conf.origem.marca.trabalhou': 'Trabalho',
    'diarias.conf.origem.marca.afastado': 'Afastamento',
    'diarias.conf.origem.marca.disposicao': 'Disposição',
    'diarias.conf.origem.marca.faltou': 'Falta',
    'diarias.conf.origem.marca.ferias': 'Férias',
    'diarias.conf.origem.marca.folga': 'Folga',
    'diarias.conf.tipo.disposicao_com_hora_extraDica': 'Alerta antigo: desde 04/09/2026 a disposição com hora extra é infração do Painel de Jornada.',
    'diarias.conf.status.pendente': 'Pendente',
    'diarias.conf.status.corrigido': 'Corrigido',
    'diarias.conf.status.justificado': 'Justificado',
    'diarias.conf.status.advertencia': 'Gestão',
    'diarias.conf.retrato.titulo': 'Na detecção',
    'diarias.conf.retrato.lancado': 'Lançado',
    'diarias.conf.retrato.tipo': 'Tipo',
    'diarias.conf.retrato.previsto': 'Previsto',
    'diarias.conf.retrato.jornada': 'Jornada',
    'diarias.conf.retrato.limite': 'Teto do dia',
    'diarias.conf.retrato.distancia': 'Distância',
    'diarias.conf.retrato.afastamento': 'Afastamento da garagem',
    'diarias.conf.retrato.detectado': 'Detectado em',
    'diarias.conf.retrato.corrigido': 'Corrigido em',
    'diarias.conf.retrato.duplaDoDia': 'Dupla do dia',
    'diarias.conf.justificar': 'Justificar',
    'diarias.conf.tratar': 'Tratar',
    'diarias.conf.editar': 'Editar',
    'diarias.conf.tratar.ok.justificado': 'Alerta justificado.',
    'diarias.conf.tratar.ok.advertencia': 'Alerta classificado como Gestão. Ele aparece no Relatório de Ocorrências do módulo de Gestões.',
    'diarias.conf.justificar.autor': '{{quem}}, {{quando}}',
    'diarias.conf.justificar.titulo': 'Justificar alerta',
    'diarias.conf.justificar.campo': 'Justificativa',
    'diarias.conf.justificar.ajuda': 'Diga por que o alerta fica como está. O texto fica na coluna Justificativa.',
    'diarias.conf.justificar.obrigatoria': 'A justificativa é obrigatória.',
    'diarias.conf.justificar.ok': 'Alerta justificado.',
    'diarias.conf.justificar.por': 'por {{quem}} em {{quando}}',
    'diarias.conf.reavaliar': 'Recalcular',
    'diarias.conf.reavaliarDica': 'Roda a conferência do período agora, sem esperar a rotina da manhã.',
    'diarias.conf.reavaliarOk': 'Conferência refeita. Alertas novos: {{criados}}. Corrigidos: {{corrigidos}}.',
  },
  en: {
    'diarias.title': 'Daily Allowances',
    'diarias.eyebrow': 'Operations',
    'diarias.loadError': 'Could not load daily allowances.',
    'diarias.retry': 'Try again',
    'diarias.grade': 'Allowances by employee',
    'diarias.empty': 'No rows in the selected period.',
    'diarias.count_one': '{{count}} row',
    'diarias.count_other': '{{count}} rows',
    'diarias.hint': 'Click the HUB column to enter a value',
    'diarias.sincronizadoEm': 'ERP read at {{hora}}',
    'diarias.semSincronia': 'The ERP has not been read yet',

    'diarias.de': 'From',
    'diarias.ate': 'To',
    'diarias.filtro.colaborador': 'Employee',
    'diarias.filtro.todos': 'All',
    'diarias.filtro.origem': 'Source',

    'diarias.grupo.identificacao': 'Employee',
    'diarias.grupo.erp': 'Entered in ERP',
    'diarias.grupo.hub': 'Decided in HUB',
    'diarias.grupo.jornada': 'Measured workday',

    'diarias.col.data': 'Date',
    'diarias.col.diaSemana': 'Weekday',
    'diarias.col.nome': 'Name',
    'diarias.col.matricula': 'Employee ID',
    'diarias.col.funcao': 'Role',
    'diarias.col.status': 'Allowance',
    'diarias.col.tipo': 'Type',
    'diarias.col.valor': 'Amount',
    'diarias.col.observacao': 'Notes',
    'diarias.col.usuario': 'By',
    'diarias.col.lancadoEm': 'On',
    'diarias.col.grupo': 'Pair that day',
    'diarias.col.estado': 'State',
    'diarias.col.statusDia': 'Measured',
    'diarias.col.direcao': 'Driving',
    'diarias.col.jornada': 'Workday',
    'diarias.col.base': 'Base',
    'diarias.col.municipio': 'Origin city',

    'diarias.origem.hub': 'HUB',
    'diarias.origem.erp': 'ERP',
    'diarias.origem.vazio': 'No entry',
    'diarias.estado.rascunho': 'HUB only',
    'diarias.estado.enviado': 'In ERP',
    'diarias.automatico': 'Automatic',
    'diarias.subidoPor': 'Uploaded by {{nome}}',


    'diarias.kpi.linhas': 'Rows',
    'diarias.kpi.linhasHint': 'employees across the period',
    'diarias.kpi.trabalho': 'Work',
    'diarias.kpi.folga': 'Day off',
    'diarias.kpi.disposicao': 'Availability',
    'diarias.kpi.diasHint': 'days in the period',
    'diarias.kpi.disponivel': 'Available',
    'diarias.kpi.disponivelHint': 'blank or available in the ERP',
    'diarias.kpi.inconsistencias': 'Inconsistencies',
    'diarias.kpi.inconsistenciasHint': 'flagged by the ERP itself',
    'diarias.kpi.doHub': 'Decided in HUB',
    'diarias.kpi.doHubHint': 'of which {{rascunhos}} not yet in the ERP',
    'diarias.kpi.valor': 'Total amount',
    'diarias.kpi.valorHint': 'summed over the filtered period',

    'diarias.lancar.titulo': 'Enter allowance',
    'diarias.lancar.limpar': 'Use what the ERP has',
    'diarias.lancar.semPermissao': 'You do not have permission to enter allowances.',
    'diarias.lancar.erro': 'Could not save the allowance.',
    'diarias.vocabNovo_one': 'The ERP started using a value this screen does not know yet: {{lista}}',
    'diarias.vocabNovo_other': 'The ERP started using {{count}} values this screen does not know yet: {{lista}}',
    'diarias.vocabNovoDica': 'The grid shows the value as it came, and the check cannot classify it. Worth telling the Protheus team and adding it to the list.',

    'diarias.export.grade': 'Download Excel',
    'diarias.export.gradeDica': 'The grid as filtered, for review.',
    'diarias.export.lancamentos': 'Export entries',
    'diarias.export.csv': 'Generate CSV',
    'diarias.export.csvDica': 'The ERP import file: branch, employee id, entry and type as codes, and notes. Takes what the HUB decided in the period and Protheus does not have yet. Entries without a reason or an ERP code are left out.',
    'diarias.codigos.abrir': 'ERP codes',
    'diarias.codigos.titulo': 'ERP codes in the CSV',
    'diarias.codigos.intro': 'The code Protheus expects for each entry and each type. An empty field keeps the known code, shown in grey. A value without a code blocks the CSV: the file is not generated, and the message lists the values still to be registered here.',
    'diarias.codigos.status': 'Entry code',
    'diarias.codigos.tipos': 'Types',
    'diarias.codigos.semCodigo': 'No code',
    'diarias.codigos.travaCsv': 'Blocks the CSV',
    'diarias.codigos.salvo': 'Codes saved. The next CSV already uses them.',
    'diarias.codigos.erro': 'The codes could not be saved.',
    'diarias.export.lancamentosDica': 'Only what the HUB decided and the ERP does not have yet.',
    'diarias.export.vazio': 'There are no rows to export.',

    'diarias.tela.diarias': 'Allowances Board',
    'diarias.tela.lancamento': 'Entry Board',
    'diarias.tela.conferencia': 'Check Board',

    'diarias.filtro.funcao': 'Role',
    'diarias.filtro.tipo': 'Type',
    'diarias.filtro.usuario': 'Entered by',
    'diarias.filtro.automatico': 'Automatic',
    'diarias.col.dupla': 'Pair',
    'diarias.col.duplaDoDiaErp': 'In the ERP, the pair on this day was {{dupla}}',
    'diarias.origem.chipHub': 'HUB',

    'diarias.status.TRABALHO': 'Work',
    'diarias.status.DISPOSICAO': 'Availability',
    'diarias.status.FOLGA': 'Day off',
    'diarias.status.DISPONIVEL': 'Available',
    'diarias.status.INCONSISTENTE': 'Inconsistent',
    'diarias.status.AFASTAMENTO': 'Leave',
    'diarias.status.FERIAS': 'Vacation',
    'diarias.status.FALTA': 'Absence',
    'diarias.status.SUSPENSAO': 'Suspension',
    'diarias.status.OUTROS': 'Other',

    'diarias.pizza.titulo': 'Allowances by status',
    'diarias.pizza.centro': 'rows',
    'diarias.pizza.vazio': 'No allowances in the filtered period.',
    'diarias.pizza.outrosDica': 'Values this screen does not know yet.',

    'diarias.duplasHoje.titulo': 'Employees by pair',
    'diarias.duplasHoje.hoje': 'as of today, {{dia}}',
    'diarias.duplasHoje.semDupla': 'No pair',
    'diarias.duplasHoje.vazio': 'Nobody on staff today.',
    'diarias.duplasHoje.trabalho': 'Work',
    'diarias.duplasHoje.folga': 'Day off',
    'diarias.duplasHoje.disponivel': 'Available',
    'diarias.duplasHoje.outros': 'Other',
    'diarias.duplasHoje.total_one': '{{count}} employee',
    'diarias.duplasHoje.total_other': '{{count}} employees',

    'diarias.seq.domingos': 'Consecutive Sundays worked',
    'diarias.seq.dias': 'Consecutive days worked',
    'diarias.seq.folgas': 'Consecutive days off',
    'diarias.seq.desde': 'since {{dia}}',
    'diarias.seq.ancora': 'measured up to {{dia}}',
    'diarias.seq.vazio': 'Nobody on a streak.',
    'diarias.seq.regra': 'Available and inconsistent neither count nor break. Leave, vacation, absence and suspension reset. Availability counts as work.',

    'diarias.lanc.grade': 'Available to enter',
    'diarias.lanc.resumo.alcance': 'Data from {{de}} to {{ate}}',
    'diarias.lanc.resumo.periodos': 'Available by payroll period',
    'diarias.lanc.resumo.periodo': 'Payroll period',
    'diarias.lanc.resumo.duplas': 'Available by pair',
    'diarias.lanc.resumo.dias': 'Available by day',
    'diarias.lanc.resumo.quantidade': 'Quantity',
    'diarias.lanc.resumo.intervalo': '{{de}} to {{ate}}',
    'diarias.lanc.resumo.semDupla': 'No pair',
    'diarias.lanc.empty': 'No available rows up to today in the filtered period.',
    'diarias.lanc.kpi.disponiveis': 'Available',
    'diarias.lanc.kpi.disponiveisHint': 'up to today, undecided',
    'diarias.lanc.kpi.alerta1': 'Available for 1 day',
    'diarias.lanc.kpi.alerta2': 'Available for 2 days',
    'diarias.lanc.kpi.alerta3': 'Available for 3 days or more',
    'diarias.lanc.kpi.alertaHint': 'click to filter',
    'diarias.lanc.filtro.alerta': 'Alert',
    'diarias.lanc.filtro.jornada': 'Workday',
    'diarias.lanc.filtro.semLancamento': 'Not entered yet',
    'diarias.lanc.alerta.1': '1 day',
    'diarias.lanc.alerta.2': '2 days',
    'diarias.lanc.alerta.3': '3 days or more',
    'diarias.lanc.jornada.sim': 'With workday',
    'diarias.lanc.jornada.nao': 'Without workday',
    'diarias.lanc.grupo.colaborador': 'Employee',
    'diarias.lanc.grupo.jornada': 'Workday',
    'diarias.lanc.grupo.lancamento': 'Entry',
    'diarias.lanc.col.cliente': 'Customer',
    'diarias.lanc.col.veiculo': 'Vehicle',
    'diarias.lanc.col.inicio': 'Start',
    'diarias.lanc.col.refeicao': 'Meal',
    'diarias.lanc.col.fim': 'End',
    'diarias.lanc.col.total': 'Total',
    'diarias.lanc.col.direcao': 'Driving',
    'diarias.lanc.col.parado': 'Stopped',
    'diarias.lanc.col.distancia': 'Distance',
    'diarias.lanc.col.responsavel': 'Entered by',
    'diarias.lanc.col.alerta': 'Alert',
    'diarias.lanc.jornadas': '{{count}} shifts on the day. The marks are from the first one.',
    'diarias.lanc.previsao': 'Forecast',
    'diarias.lanc.previsaoDica': 'What the HUB would forecast for this day from the workday. The morning routine saves the forecast by itself.',
    'diarias.lanc.salvo': 'Draft saved. The allowance will be confirmed after it is recorded in Protheus.',
    'diarias.lanc.semGaragem_one': 'Base {{lista}} has no garage registered in Places. The automatic forecast stays blank for it.',
    'diarias.lanc.semGaragem_other': 'Bases {{lista}} have no garage registered in Places. The automatic forecast stays blank for them.',
    'diarias.lanc.semGaragemDica': 'Register the place with the Garage category, the city in the name and the coordinates. The 30 km radius is measured from it.',
    'diarias.previsao.TRABALHO': 'Work',
    'diarias.previsao.DISPOSICAO_FORA': 'Availability away from base',
    'diarias.previsao.DISPOSICAO_DENTRO': 'Availability at base',
    'diarias.previsao.DISPOSICAO_GARAGEM': 'Availability at garage',
    'diarias.previsao.FOLGA': 'Day off',
    'diarias.origem.chipPrevisto': 'HUB',
    'diarias.origem.previstoDica': 'Forecast automatically from the workday. To change it, pick the allowance that applied.',

    'diarias.conf.grade': 'Check alerts',
    'diarias.conf.empty': 'No alerts in the filtered period.',
    'diarias.conf.count_one': '{{count}} alert',
    'diarias.conf.count_other': '{{count}} alerts',
    'diarias.conf.inicio': 'checks since {{dia}}',
    'diarias.conf.kpi.total': 'Alerts',
    'diarias.conf.kpi.totalHint': 'in the filtered period',
    'diarias.conf.kpi.pendente': 'Pending',
    'diarias.conf.kpi.corrigido': 'Fixed',
    'diarias.conf.kpi.justificado': 'Justified',
    'diarias.conf.kpi.advertencia': 'Measures',
    'diarias.conf.kpi.statusHint': 'click to filter',
    'diarias.conf.filtro.tipo': 'Alert',
    'diarias.conf.filtro.status': 'Check status',
    'diarias.conf.col.responsavel': 'Entered by',
    'diarias.conf.col.alerta': 'Alert',
    'diarias.conf.col.status': 'Status',
    'diarias.conf.col.justificativa': 'Justification',
    'diarias.conf.col.jornada': 'Workday',
    'diarias.conf.col.distancia': 'Distance',
    'diarias.conf.tipo.folga_com_jornada': 'Day off with workday',
    'diarias.conf.tipo.falta_com_jornada': 'Absence with workday',
    'diarias.conf.tipo.suspensao_com_jornada': 'Suspension with workday',
    'diarias.conf.tipo.ferias_com_jornada': 'Vacation with workday',
    'diarias.conf.tipo.afastamento_com_jornada': 'Leave with workday',
    'diarias.conf.tipo.ociosos_com_jornada': 'Idle with workday',
    'diarias.conf.tipo.trabalho_incorreto': 'Wrong work',
    'diarias.conf.tipo.disposicao_incorreta': 'Wrong availability',
    'diarias.conf.tipo.lancamento_inconsistente': 'Inconsistent entry',
    'diarias.conf.tipo.diaria_duplicada': 'Duplicate allowance',
    'diarias.conf.tipo.disposicao_com_hora_extra': 'Availability with overtime',
    'diarias.conf.tipo.folga_com_jornadaDica': 'The allowance says day off and a shift was opened that day.',
    'diarias.conf.tipo.falta_com_jornadaDica': 'The allowance says absence and a shift was opened that day.',
    'diarias.conf.tipo.suspensao_com_jornadaDica': 'The allowance says suspension and a shift was opened that day.',
    'diarias.conf.tipo.ferias_com_jornadaDica': 'The allowance says vacation and a shift was opened that day.',
    'diarias.conf.tipo.afastamento_com_jornadaDica': 'The allowance says leave and a shift was opened that day.',
    'diarias.conf.tipo.ociosos_com_jornadaDica': 'There is a shift that day and Protheus scheduled the person in the idle employees pair. It applies whatever the allowance, and becomes Fixed when Protheus takes the person out of the idle pair, for that day or in the registry.',
    'diarias.conf.tipo.trabalho_incorretoDica': 'Work was entered and it is wrong. Drivers and trailer drivers: the shift indicates Availability. Operators and yard drivers: Work entered with no shift that day.',
    'diarias.conf.tipo.disposicao_incorretaDica': 'Availability was entered and it is wrong: the shift indicates Work, or it is Availability on the other side of the base.',
    'diarias.conf.tipo.lancamento_inconsistenteDica': 'Protheus itself classified the day as inconsistent. It does so when the day schedule has more than one type marked, such as work and day off.',
    'diarias.conf.tipo.diaria_duplicadaDica': 'Protheus returned two or more entries for the same employee on the same day. The HUB checks the first one and keeps all of them here.',
    'diarias.conf.origem.titulo': 'Entries in the ERP',
    'diarias.conf.origem.lancamento': 'Entry {{n}}',
    'diarias.conf.origem.marcado': 'Marked',
    'diarias.conf.origem.observacao': 'Note',
    'diarias.conf.origem.usuario': 'Entered by',
    'diarias.conf.origem.data': 'Entered on',
    'diarias.conf.origem.semMarca': 'No type marked',
    'diarias.conf.origem.semMarcasDoErp': 'Snapshot from before 23/09/2026, when the ERP did not send Absence, Vacation and Day off yet. While the alert is pending, it is refreshed on the next ERP read.',
    'diarias.conf.origem.marca.trabalhou': 'Work',
    'diarias.conf.origem.marca.afastado': 'Leave',
    'diarias.conf.origem.marca.disposicao': 'Standby',
    'diarias.conf.origem.marca.faltou': 'Absence',
    'diarias.conf.origem.marca.ferias': 'Vacation',
    'diarias.conf.origem.marca.folga': 'Day off',
    'diarias.conf.tipo.disposicao_com_hora_extraDica': 'Legacy alert: since 04/09/2026 availability with overtime is an infraction on the Workday Panel.',
    'diarias.conf.status.pendente': 'Pending',
    'diarias.conf.status.corrigido': 'Fixed',
    'diarias.conf.status.justificado': 'Justified',
    'diarias.conf.status.advertencia': 'Measure',
    'diarias.conf.retrato.titulo': 'When detected',
    'diarias.conf.retrato.lancado': 'Entered',
    'diarias.conf.retrato.tipo': 'Type',
    'diarias.conf.retrato.previsto': 'Forecast',
    'diarias.conf.retrato.jornada': 'Workday',
    'diarias.conf.retrato.limite': 'Day cap',
    'diarias.conf.retrato.distancia': 'Distance',
    'diarias.conf.retrato.afastamento': 'Distance from garage',
    'diarias.conf.retrato.detectado': 'Detected on',
    'diarias.conf.retrato.corrigido': 'Fixed on',
    'diarias.conf.retrato.duplaDoDia': 'Pair of the day',
    'diarias.conf.justificar': 'Justify',
    'diarias.conf.tratar': 'Handle',
    'diarias.conf.editar': 'Edit',
    'diarias.conf.tratar.ok.justificado': 'Alert justified.',
    'diarias.conf.tratar.ok.advertencia': 'Alert classified as a measure. It shows in the Occurrence report of the Measures module.',
    'diarias.conf.justificar.autor': '{{quem}}, {{quando}}',
    'diarias.conf.justificar.titulo': 'Justify alert',
    'diarias.conf.justificar.campo': 'Justification',
    'diarias.conf.justificar.ajuda': 'Say why the alert stays as it is. The text goes to the Justification column.',
    'diarias.conf.justificar.obrigatoria': 'The justification is required.',
    'diarias.conf.justificar.ok': 'Alert justified.',
    'diarias.conf.justificar.por': 'by {{quem}} on {{quando}}',
    'diarias.conf.reavaliar': 'Recalculate',
    'diarias.conf.reavaliarDica': 'Runs the check for the period now, without waiting for the morning routine.',
    'diarias.conf.reavaliarOk': 'Check redone. New alerts: {{criados}}. Fixed: {{corrigidos}}.',
  },
  es: {
    'diarias.title': 'Panel de Viáticos',
    'diarias.eyebrow': 'Operación',
    'diarias.loadError': 'No fue posible cargar los viáticos.',
    'diarias.retry': 'Intentar de nuevo',
    'diarias.grade': 'Viáticos por colaborador',
    'diarias.empty': 'Ninguna línea en el período filtrado.',
    'diarias.count_one': '{{count}} línea',
    'diarias.count_other': '{{count}} líneas',
    'diarias.hint': 'Haga clic en la columna del HUB para registrar',
    'diarias.sincronizadoEm': 'ERP leído a las {{hora}}',
    'diarias.semSincronia': 'El ERP aún no fue leído',

    'diarias.de': 'Desde',
    'diarias.ate': 'Hasta',
    'diarias.filtro.colaborador': 'Colaborador',
    'diarias.filtro.todos': 'Todos',
    'diarias.filtro.origem': 'Origen',

    'diarias.grupo.identificacao': 'Colaborador',
    'diarias.grupo.erp': 'Registrado en el ERP',
    'diarias.grupo.hub': 'Decidido en el HUB',
    'diarias.grupo.jornada': 'Jornada medida',

    'diarias.col.data': 'Fecha',
    'diarias.col.diaSemana': 'Día',
    'diarias.col.nome': 'Nombre',
    'diarias.col.matricula': 'Matrícula',
    'diarias.col.funcao': 'Función',
    'diarias.col.status': 'Viático',
    'diarias.col.tipo': 'Tipo',
    'diarias.col.valor': 'Valor',
    'diarias.col.observacao': 'Observación',
    'diarias.col.usuario': 'Por',
    'diarias.col.lancadoEm': 'El',
    'diarias.col.grupo': 'Dupla del día',
    'diarias.col.estado': 'Situación',
    'diarias.col.statusDia': 'Medido',
    'diarias.col.direcao': 'Conducción',
    'diarias.col.jornada': 'Jornada',
    'diarias.col.base': 'Base',
    'diarias.col.municipio': 'Municipio origen',

    'diarias.origem.hub': 'HUB',
    'diarias.origem.erp': 'ERP',
    'diarias.origem.vazio': 'Sin registro',
    'diarias.estado.rascunho': 'Solo en el HUB',
    'diarias.estado.enviado': 'En el ERP',
    'diarias.automatico': 'Automático',
    'diarias.subidoPor': 'Subido por {{nome}}',


    'diarias.kpi.linhas': 'Líneas',
    'diarias.kpi.linhasHint': 'colaboradores por días del período',
    'diarias.kpi.trabalho': 'Trabajo',
    'diarias.kpi.folga': 'Descanso',
    'diarias.kpi.disposicao': 'Disposición',
    'diarias.kpi.diasHint': 'días en el período',
    'diarias.kpi.disponivel': 'Disponible',
    'diarias.kpi.disponivelHint': 'en blanco o disponible en el ERP',
    'diarias.kpi.inconsistencias': 'Inconsistencias',
    'diarias.kpi.inconsistenciasHint': 'marcadas por el propio ERP',
    'diarias.kpi.doHub': 'Decididos en el HUB',
    'diarias.kpi.doHubHint': 'de los cuales {{rascunhos}} aún fuera del ERP',
    'diarias.kpi.valor': 'Valor total',
    'diarias.kpi.valorHint': 'sumado en el período filtrado',

    'diarias.lancar.titulo': 'Registrar viático',
    'diarias.lancar.limpar': 'Usar lo que tiene el ERP',
    'diarias.lancar.semPermissao': 'No tiene permiso para registrar viáticos.',
    'diarias.lancar.erro': 'No fue posible guardar el viático.',
    'diarias.vocabNovo_one': 'El ERP pasó a usar un valor que esta pantalla aún no conoce: {{lista}}',
    'diarias.vocabNovo_other': 'El ERP pasó a usar {{count}} valores que esta pantalla aún no conoce: {{lista}}',
    'diarias.vocabNovoDica': 'La grilla muestra el valor como vino, y la verificación no sabe clasificarlo. Conviene avisar al equipo de Protheus y agregarlo a la lista.',

    'diarias.export.grade': 'Descargar Excel',
    'diarias.export.gradeDica': 'La grilla como está filtrada, para verificación.',
    'diarias.export.lancamentos': 'Exportar registros',
    'diarias.export.csv': 'Generar CSV',
    'diarias.export.csvDica': 'El archivo de importación del ERP: sucursal, matrícula, registro y tipo como código, y observación. Lleva lo que el HUB decidió en el período y Protheus aún no tiene. El registro sin motivo o sin código del ERP queda fuera.',
    'diarias.codigos.abrir': 'Códigos del ERP',
    'diarias.codigos.titulo': 'Códigos del ERP en el CSV',
    'diarias.codigos.intro': 'El código que Protheus espera para cada registro y cada tipo. El campo vacío vale el código ya conocido, mostrado en gris. Un valor sin código bloquea el CSV: el archivo no sale, y el mensaje dice qué valores faltan registrar aquí.',
    'diarias.codigos.status': 'Código del registro',
    'diarias.codigos.tipos': 'Tipos',
    'diarias.codigos.semCodigo': 'Sin código',
    'diarias.codigos.travaCsv': 'Bloquea el CSV',
    'diarias.codigos.salvo': 'Códigos guardados. El próximo CSV ya sale con ellos.',
    'diarias.codigos.erro': 'No se pudieron guardar los códigos.',
    'diarias.export.lancamentosDica': 'Solo lo que el HUB decidió y el ERP aún no tiene.',
    'diarias.export.vazio': 'No hay líneas para exportar.',

    'diarias.tela.diarias': 'Panel de Viáticos',
    'diarias.tela.lancamento': 'Panel de Registro',
    'diarias.tela.conferencia': 'Panel de Verificación',

    'diarias.filtro.funcao': 'Función',
    'diarias.filtro.tipo': 'Tipo',
    'diarias.filtro.usuario': 'Responsable del registro',
    'diarias.filtro.automatico': 'Automático',
    'diarias.col.dupla': 'Dupla',
    'diarias.col.duplaDoDiaErp': 'En el ERP, la dupla de este día era {{dupla}}',
    'diarias.origem.chipHub': 'HUB',

    'diarias.status.TRABALHO': 'Trabajo',
    'diarias.status.DISPOSICAO': 'Disposición',
    'diarias.status.FOLGA': 'Descanso',
    'diarias.status.DISPONIVEL': 'Disponible',
    'diarias.status.INCONSISTENTE': 'Inconsistente',
    'diarias.status.AFASTAMENTO': 'Ausencia',
    'diarias.status.FERIAS': 'Vacaciones',
    'diarias.status.FALTA': 'Falta',
    'diarias.status.SUSPENSAO': 'Suspensión',
    'diarias.status.OUTROS': 'Otros',

    'diarias.pizza.titulo': 'Viáticos por estado',
    'diarias.pizza.centro': 'líneas',
    'diarias.pizza.vazio': 'Ningún viático en el período filtrado.',
    'diarias.pizza.outrosDica': 'Valores que esta pantalla aún no conoce.',

    'diarias.duplasHoje.titulo': 'Colaboradores por dupla',
    'diarias.duplasHoje.hoje': 'situación de hoy, {{dia}}',
    'diarias.duplasHoje.semDupla': 'Sin dupla',
    'diarias.duplasHoje.vazio': 'Nadie en plantilla hoy.',
    'diarias.duplasHoje.trabalho': 'Trabajo',
    'diarias.duplasHoje.folga': 'Descanso',
    'diarias.duplasHoje.disponivel': 'Disponible',
    'diarias.duplasHoje.outros': 'Otros',
    'diarias.duplasHoje.total_one': '{{count}} colaborador',
    'diarias.duplasHoje.total_other': '{{count}} colaboradores',

    'diarias.seq.domingos': 'Domingos trabajados seguidos',
    'diarias.seq.dias': 'Días trabajados seguidos',
    'diarias.seq.folgas': 'Descansos seguidos',
    'diarias.seq.desde': 'desde {{dia}}',
    'diarias.seq.ancora': 'medido hasta {{dia}}',
    'diarias.seq.vazio': 'Nadie en secuencia.',
    'diarias.seq.regra': 'Disponible e inconsistente no cuentan ni interrumpen. Ausencia, vacaciones, falta y suspensión reinician. Disposición cuenta como trabajo.',

    'diarias.lanc.grade': 'Disponibles para registrar',
    'diarias.lanc.resumo.alcance': 'Datos del {{de}} al {{ate}}',
    'diarias.lanc.resumo.periodos': 'Disponibles por período de nómina',
    'diarias.lanc.resumo.periodo': 'Período de nómina',
    'diarias.lanc.resumo.duplas': 'Disponibles por dupla',
    'diarias.lanc.resumo.dias': 'Disponibles por día',
    'diarias.lanc.resumo.quantidade': 'Cantidad',
    'diarias.lanc.resumo.intervalo': '{{de}} a {{ate}}',
    'diarias.lanc.resumo.semDupla': 'Sin dupla',
    'diarias.lanc.empty': 'Ninguna línea disponible hasta hoy en el período filtrado.',
    'diarias.lanc.kpi.disponiveis': 'Disponibles',
    'diarias.lanc.kpi.disponiveisHint': 'hasta hoy, sin decisión',
    'diarias.lanc.kpi.alerta1': 'Disponible hace 1 día',
    'diarias.lanc.kpi.alerta2': 'Disponible hace 2 días',
    'diarias.lanc.kpi.alerta3': 'Disponible hace 3 días o más',
    'diarias.lanc.kpi.alertaHint': 'clic para filtrar',
    'diarias.lanc.filtro.alerta': 'Alerta',
    'diarias.lanc.filtro.jornada': 'Jornada',
    'diarias.lanc.filtro.semLancamento': 'Sin registro',
    'diarias.lanc.alerta.1': '1 día',
    'diarias.lanc.alerta.2': '2 días',
    'diarias.lanc.alerta.3': '3 días o más',
    'diarias.lanc.jornada.sim': 'Con jornada',
    'diarias.lanc.jornada.nao': 'Sin jornada',
    'diarias.lanc.grupo.colaborador': 'Colaborador',
    'diarias.lanc.grupo.jornada': 'Jornada',
    'diarias.lanc.grupo.lancamento': 'Registro',
    'diarias.lanc.col.cliente': 'Cliente',
    'diarias.lanc.col.veiculo': 'Vehículo',
    'diarias.lanc.col.inicio': 'Inicio',
    'diarias.lanc.col.refeicao': 'Comida',
    'diarias.lanc.col.fim': 'Fin',
    'diarias.lanc.col.total': 'Total',
    'diarias.lanc.col.direcao': 'Conducción',
    'diarias.lanc.col.parado': 'Parado',
    'diarias.lanc.col.distancia': 'Distancia',
    'diarias.lanc.col.responsavel': 'Responsable',
    'diarias.lanc.col.alerta': 'Alerta',
    'diarias.lanc.jornadas': '{{count}} jornadas en el día. Las marcas son de la primera.',
    'diarias.lanc.previsao': 'Previsión',
    'diarias.lanc.previsaoDica': 'Lo que el HUB preveería para este día por la jornada. La rutina de la mañana guarda la previsión sola.',
    'diarias.lanc.salvo': 'Borrador guardado. El viático se confirmará tras registrarse en Protheus.',
    'diarias.lanc.semGaragem_one': 'La base {{lista}} no tiene garaje registrado en Lugares. La previsión automática queda en blanco para ella.',
    'diarias.lanc.semGaragem_other': 'Las bases {{lista}} no tienen garaje registrado en Lugares. La previsión automática queda en blanco para ellas.',
    'diarias.lanc.semGaragemDica': 'Registre el lugar con la categoría Garaje, la ciudad en el nombre y la coordenada. El radio de 30 km se mide desde él.',
    'diarias.previsao.TRABALHO': 'Trabajo',
    'diarias.previsao.DISPOSICAO_FORA': 'Disposición fuera de la base',
    'diarias.previsao.DISPOSICAO_DENTRO': 'Disposición en la base',
    'diarias.previsao.DISPOSICAO_GARAGEM': 'Disposición en el garaje',
    'diarias.previsao.FOLGA': 'Descanso',
    'diarias.origem.chipPrevisto': 'HUB',
    'diarias.origem.previstoDica': 'Previsto automáticamente por la jornada. Para cambiarlo, elija el viático que valió.',

    'diarias.conf.grade': 'Alertas de la verificación',
    'diarias.conf.empty': 'Ninguna alerta en el período filtrado.',
    'diarias.conf.count_one': '{{count}} alerta',
    'diarias.conf.count_other': '{{count}} alertas',
    'diarias.conf.inicio': 'verificaciones desde {{dia}}',
    'diarias.conf.kpi.total': 'Alertas',
    'diarias.conf.kpi.totalHint': 'en el período filtrado',
    'diarias.conf.kpi.pendente': 'Pendientes',
    'diarias.conf.kpi.corrigido': 'Corregidas',
    'diarias.conf.kpi.justificado': 'Justificadas',
    'diarias.conf.kpi.advertencia': 'Gestiones',
    'diarias.conf.kpi.statusHint': 'clic para filtrar',
    'diarias.conf.filtro.tipo': 'Alerta',
    'diarias.conf.filtro.status': 'Estado de la verificación',
    'diarias.conf.col.responsavel': 'Responsable del registro',
    'diarias.conf.col.alerta': 'Alerta',
    'diarias.conf.col.status': 'Estado',
    'diarias.conf.col.justificativa': 'Justificación',
    'diarias.conf.col.jornada': 'Jornada',
    'diarias.conf.col.distancia': 'Distancia',
    'diarias.conf.tipo.folga_com_jornada': 'Descanso con jornada',
    'diarias.conf.tipo.falta_com_jornada': 'Falta con jornada',
    'diarias.conf.tipo.suspensao_com_jornada': 'Suspensión con jornada',
    'diarias.conf.tipo.ferias_com_jornada': 'Vacaciones con jornada',
    'diarias.conf.tipo.afastamento_com_jornada': 'Ausencia con jornada',
    'diarias.conf.tipo.ociosos_com_jornada': 'Ocioso con jornada',
    'diarias.conf.tipo.trabalho_incorreto': 'Trabajo incorrecto',
    'diarias.conf.tipo.disposicao_incorreta': 'Disposición incorrecta',
    'diarias.conf.tipo.lancamento_inconsistente': 'Registro inconsistente',
    'diarias.conf.tipo.diaria_duplicada': 'Viático duplicado',
    'diarias.conf.tipo.disposicao_com_hora_extra': 'Disposición con hora extra',
    'diarias.conf.tipo.folga_com_jornadaDica': 'El viático dice descanso y hay jornada abierta en el día.',
    'diarias.conf.tipo.falta_com_jornadaDica': 'El viático dice falta y hay jornada abierta en el día.',
    'diarias.conf.tipo.suspensao_com_jornadaDica': 'El viático dice suspensión y hay jornada abierta en el día.',
    'diarias.conf.tipo.ferias_com_jornadaDica': 'El viático dice vacaciones y hay jornada abierta en el día.',
    'diarias.conf.tipo.afastamento_com_jornadaDica': 'El viático dice ausencia y hay jornada abierta en el día.',
    'diarias.conf.tipo.ociosos_com_jornadaDica': 'Hay jornada en el día y Protheus programó a la persona en la dupla de los empleados ociosos. Vale cualquiera que sea el viático, y pasa a Corregido cuando Protheus saca a la persona de la dupla de ociosos en el día o en el registro.',
    'diarias.conf.tipo.trabalho_incorretoDica': 'Lo registrado es Trabajo y está mal. Conductor y planchero: la jornada indica Disposición. Operador y maniobra: Trabajo registrado sin jornada en el día.',
    'diarias.conf.tipo.disposicao_incorretaDica': 'Lo registrado es Disposición y está mal: la jornada indica Trabajo, o es Disposición del otro lado de la base.',
    'diarias.conf.tipo.lancamento_inconsistenteDica': 'El propio Protheus clasificó el día como inconsistente. Lo hace cuando la programación del día tiene más de un tipo marcado, como trabajo y descanso.',
    'diarias.conf.tipo.diaria_duplicadaDica': 'Protheus devolvió dos o más registros para el mismo colaborador en el mismo día. El HUB confiere el primero y guarda todos aquí.',
    'diarias.conf.origem.titulo': 'Registros en el ERP',
    'diarias.conf.origem.lancamento': 'Registro {{n}}',
    'diarias.conf.origem.marcado': 'Marcado',
    'diarias.conf.origem.observacao': 'Observación',
    'diarias.conf.origem.usuario': 'Registrado por',
    'diarias.conf.origem.data': 'Registrado el',
    'diarias.conf.origem.semMarca': 'Ningún tipo marcado',
    'diarias.conf.origem.semMarcasDoErp': 'Registro de antes del 23/09/2026, cuando el ERP todavía no enviaba Falta, Vacaciones y Descanso. Mientras la alerta esté pendiente, se actualiza en la próxima lectura del ERP.',
    'diarias.conf.origem.marca.trabalhou': 'Trabajo',
    'diarias.conf.origem.marca.afastado': 'Ausencia',
    'diarias.conf.origem.marca.disposicao': 'Disposición',
    'diarias.conf.origem.marca.faltou': 'Falta',
    'diarias.conf.origem.marca.ferias': 'Vacaciones',
    'diarias.conf.origem.marca.folga': 'Descanso',
    'diarias.conf.tipo.disposicao_com_hora_extraDica': 'Alerta antigua: desde el 04/09/2026 la disposición con hora extra es infracción del Panel de Jornada.',
    'diarias.conf.status.pendente': 'Pendiente',
    'diarias.conf.status.corrigido': 'Corregida',
    'diarias.conf.status.justificado': 'Justificada',
    'diarias.conf.status.advertencia': 'Gestión',
    'diarias.conf.retrato.titulo': 'En la detección',
    'diarias.conf.retrato.lancado': 'Registrado',
    'diarias.conf.retrato.tipo': 'Tipo',
    'diarias.conf.retrato.previsto': 'Previsto',
    'diarias.conf.retrato.jornada': 'Jornada',
    'diarias.conf.retrato.limite': 'Tope del día',
    'diarias.conf.retrato.distancia': 'Distancia',
    'diarias.conf.retrato.afastamento': 'Distancia al garaje',
    'diarias.conf.retrato.detectado': 'Detectada el',
    'diarias.conf.retrato.corrigido': 'Corregida el',
    'diarias.conf.retrato.duplaDoDia': 'Dupla del día',
    'diarias.conf.justificar': 'Justificar',
    'diarias.conf.tratar': 'Tratar',
    'diarias.conf.editar': 'Editar',
    'diarias.conf.tratar.ok.justificado': 'Alerta justificada.',
    'diarias.conf.tratar.ok.advertencia': 'Alerta clasificada como gestión. Aparece en el Informe de ocurrencias del módulo de Gestiones.',
    'diarias.conf.justificar.autor': '{{quem}}, {{quando}}',
    'diarias.conf.justificar.titulo': 'Justificar alerta',
    'diarias.conf.justificar.campo': 'Justificación',
    'diarias.conf.justificar.ajuda': 'Diga por qué la alerta queda como está. El texto va a la columna Justificación.',
    'diarias.conf.justificar.obrigatoria': 'La justificación es obligatoria.',
    'diarias.conf.justificar.ok': 'Alerta justificada.',
    'diarias.conf.justificar.por': 'por {{quem}} el {{quando}}',
    'diarias.conf.reavaliar': 'Recalcular',
    'diarias.conf.reavaliarDica': 'Ejecuta la verificación del período ahora, sin esperar la rutina de la mañana.',
    'diarias.conf.reavaliarOk': 'Verificación rehecha. Alertas nuevas: {{criados}}. Corregidas: {{corrigidos}}.',
  },
}
